exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon[data-v-150bd6bc]{width:0.5rem;height:0.5rem;vertical-align:-0.15em;fill:currentColor;overflow:hidden\n}\n", ""]);

// exports
